import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { InsurancePolicy } from './insurance-policy';
import { Site } from './site';

export class InsurancePolicySite extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static InsurancePolicySiteProperties: (
    | {
        property: keyof InsurancePolicySite;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof InsurancePolicySite;
        type: 'alias';
      }
    | {
        property: keyof InsurancePolicySite;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'SiteId', type: 'column', dataType: 'number' },
    { property: 'InsurancePolicyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Site', model: 'Site', type: 'association' },
    {
      property: 'InsurancePolicy',
      model: 'InsurancePolicy',
      type: 'association'
    }
  ];

  static {
    InsurancePolicySite.InsurancePolicySiteProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          InsurancePolicySite.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          InsurancePolicySite.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          InsurancePolicySite.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(InsurancePolicySiteObject: Partial<InsurancePolicySite>) {
    super();

    InsurancePolicySite.InsurancePolicySiteProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = InsurancePolicySiteObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  SiteId?: number;
  InsurancePolicyId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Site?: Site;
  InsurancePolicy?: InsurancePolicy;
}
